<template>
  <div class="container-custom">
    <!-- Breadscrumbs -->
    <Breadscrumbs
      :links="[{ name: 'StoryCenter', to: { path: '/story-center' } }]"
    ></Breadscrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>Success Story</h2>
      <v-spacer></v-spacer>
      <button class="btn btn-primary" @click="toStoryCreate">
        <v-icon class="mr-2 white--text">add</v-icon>
        <span>新增案例</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <StoryCenterTable></StoryCenterTable>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import StoryCenterTable from '@/views/E-5__SuccessStory/c/SuccessStoryCenterTable.vue';

export default {
  components: {
    Breadscrumbs,
    StoryCenterTable,
  },
  created() {
    this.clear();
    this.getStoryList();
  },
  methods: {
    ...mapActions('story', {
      getStoryList: 'find',
      clear: 'clear',
    }),
    toStoryCreate() {
      this.$router.push('/story-center/create');
    },
  },
};
</script>

<style></style>
